/**
 *
 * App.js
 *
 */

import {
  ThemeProvider,
  createTheme,
} from "@mui/material/styles";
import React, { useEffect } from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import Routes from "../../components/Routes";
import { getUserConfirmation } from "./getUserConfirmation";

const theme = createTheme({
  palette: {
    primary: { main: "#004c97" }, // Purple and green play nicely together.
    secondary: { main: "#0076cf" } // This is just green.A700 as hex.
  }
});

const App = () => {
  const GTM_ID = "GTM-WT5ZVQQ";
  useEffect(() => {
    const nonce = document
      .querySelector("meta[name='csp-nonce']")
      ?.getAttribute("content");

    const scriptTemplate = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;var n=d.querySelector('[nonce]');
    n&&j.setAttribute('nonce', '${nonce}');f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GTM_ID}');`;

    const noScriptTemplate = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}&gtm_auth=&gtm_preview=&gtm_cookies_win=x"
      height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>`;

    const script = document.createElement("script");
    const noScript = document.createElement("noscript");

    if (nonce) {
      script.setAttribute("nonce", nonce);
    }

    script.textContent = scriptTemplate;
    noScript.textContent = noScriptTemplate;

    document.head.insertBefore(script, document.head.firstChild);
    document.body.insertBefore(noScript, document.body.firstChild);

    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noScript);
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter getUserConfirmation={getUserConfirmation}>
        <Switch>
          <Routes />
        </Switch>
      </BrowserRouter>
    </ThemeProvider>
  );
};
export default App;
